import React from "react";

class FAQ extends React.Component {
  render () {
    return (
      <div>
        <h2>
          FAQs
        </h2>
        <hr/>
        <div>
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                  What if I don’t know my temperature?
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div class="accordion-body custom-font-faq">
                  For your temperature, you can either provide a numeric value of your temperature (in Fahrenheit) or, if you don’t know your temperature, you can tell COVID-R whether or not you currently have a fever. Please note, if you enter your numeric temperature, you will need to enter your numeric blood pressure value later; if you choose to proceed with the second option, later you will be asked whether or not you have high blood pressure.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Do males and females have the same risk of COVID-19?
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body custom-font-faq">
                  According to our analysis, biological sex is a risk factor of COVID-19. In order to minimize the burden of the users, we only include the most significant risk factors in COVID-R. That's the reason we did not include biological sex in COVID-R.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  I heard that blood type is a risk factor of COVID-19. Why does COVID-R not include it?
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div class="accordion-body custom-font-faq">
                  Blood type is truly a risk factor of COVID-19 from our analysis. However, the purpose of COVID-R is for people to use at home, without having medical tests. A lot of people may not know their blood types. Another example is oxygen saturation, which is an important predictor of COVID-19. But we did not implement it in COVID-R, because many people don’t have the measure.
                </div>
              </div>
            </div>
          </div>
          {/* <div>
            <h3>What if I don’t know my temperature?</h3>
            <p>For your temperature, you can either provide a numeric value of your temperature (in Fahrenheit) or, if you don’t know your temperature, you can tell COVID-R whether or not you currently have a fever. Please note, if you enter your numeric temperature, you will need to enter your numeric blood pressure value later; if you choose to proceed with the second option, later you will be asked whether or not you have high blood pressure.</p>
          </div>
          <div>
            <h3>Do males and females have the same risk of COVID-19?</h3>
            <p>According to our analysis, biological sex is a risk factor of COVID-19. In order to minimize the burden of the users, we only include the most significant risk factors in COVID-R. That's the reason we did not include biological sex in COVID-R. </p>
          </div>
          <div>
            <h3>I heard that blood type is a risk factor of COVID-19. Why does COVID-R not include it?</h3>
            <p>Blood type is truly a risk factor of COVID-19 from our analysis. However, the purpose of COVID-R is for people to use at home, without having medical tests. A lot of people may not know their blood types. Another example is oxygen saturation, which is an important predictor of COVID-19. But we did not implement it in COVID-R, because many people don’t have the measure.</p>
          </div> */}
        </div>
      </div>
    )
  }
}

export default FAQ;